import React from 'react';
import EcontOfficeSelector from './EcontOfficeSelector';
import SpeedyOfficeSelector from './SpeedyOfficeSelector';
import PickupAddressDisplay from './PickupAddressDisplay';
import AddressShippingForm from './AddressShippingForm';
import { FaCheck, FaStore, FaHome } from 'react-icons/fa';

const ShippingMethodSelector = ({
  loadingShipping,
  shippingOptions,
  cart,
  handleSelectShippingMethod,
  // За Econt (метод 2)
  selectedCityId,
  setSelectedCityId,
  cities,
  filteredOffices,
  selectedOffice,
  setSelectedOffice,
  // За Speedy (метод 3)
  selectedSiteId,
  setSelectedSiteId,
  sites,
  filteredSpeedy2Offices,
  selectedSpeedy2Office,
  setSelectedSpeedy2Office,
  // За доставка до адрес (метод 5)
  formData,
  handleInputChange,
  // Константи
  SPECIAL_SHIPPING_INSTANCE_ID,
  SPECIAL_SHIPPING_INSTANCE_ID_2,
  PICKUP_SHIPPING_INSTANCE_ID,
  ADDRESS_SHIPPING_INSTANCE_ID
}) => {
  // Helper to render the appropriate icon or logo for each shipping method
  const renderShippingIcon = (optionId) => {
    if (optionId === SPECIAL_SHIPPING_INSTANCE_ID) {
      return <img src="/logo_econt.png" alt="Econt" className="h-5 mr-2" />;
    } else if (optionId === SPECIAL_SHIPPING_INSTANCE_ID_2) {
      return <img src="/logo_speedy.png" alt="Speedy" className="h-5 mr-2" />;
    } else if (optionId === PICKUP_SHIPPING_INSTANCE_ID) {
      return <FaStore className="text-gray-700 mr-2" size={18} />;
    } else if (optionId === ADDRESS_SHIPPING_INSTANCE_ID) {
      return <FaHome className="text-gray-700 mr-2" size={18} />;
    }
    return null;
  };

  return (
    <div className="bg-white border border-gray-200 rounded-lg p-6">
      <div className="flex items-center mb-4">
        <div className="text-amber-500 mr-2">
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M13 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V9z"></path>
            <polyline points="13 2 13 9 20 9"></polyline>
          </svg>
        </div>
        <h3 className="font-bold text-lg">МЕТОД ЗА ДОСТАВКА</h3>
      </div>
      
      {loadingShipping ? (
        <div className="py-8 flex flex-col items-center justify-center">
          <div className="animate-spin rounded-full h-10 w-10 border-b-2 border-primary"></div>
        </div>
      ) : shippingOptions.length === 0 ? (
        <div className="py-4 text-red-600 text-center border border-dashed border-gray-200 rounded-md">
          Няма налични опции за доставка за вашето местоположение.
        </div>
      ) : (
        <div className="flex flex-col">
          {shippingOptions.map((option) => {
            const isSelected = cart.shippingMethod?.instance_id === option.instance_id;
            return (
              <div 
                key={option.instance_id}
                className={`border ${isSelected ? 'border-green-500' : 'border-gray-200'} ${!isSelected && 'border-b-0 last:border-b'}`}
              >
                <div 
                  onClick={() => handleSelectShippingMethod(option)}
                  className={`flex items-center justify-between p-3 cursor-pointer ${isSelected ? 'bg-white' : 'bg-gray-50'}`}
                >
                  <div className="flex items-center">
                    <div className={`flex items-center justify-center w-6 h-6 mr-3 ${isSelected ? 'bg-white border border-green-500' : 'bg-red-600'}`}>
                      {isSelected ? (
                        <FaCheck className="text-green-500" size={14} />
                      ) : (
                        <div className="w-4 h-4 bg-white"></div>
                      )}
                    </div>
                    <div className="flex items-center">
                      {renderShippingIcon(option.instance_id)}
                      <span className="font-medium">
                        {option.title.toLowerCase().includes('speedy') ? 'До офис на Спиди' : 
                         option.title.toLowerCase().includes('econt') ? 'До офис на Еконт' : 
                         option.title.toLowerCase().includes('вземане') ? 'Вземане от магазина' :
                         option.title.toLowerCase().includes('адрес') ? 'До адрес' :
                         option.title}
                      </span>
                    </div>
                  </div>
                  <div className="font-bold text-right">
                    {parseFloat(option.cost).toFixed(2)} лв
                  </div>
                </div>
                
                {isSelected && (
                  <div className="p-4 border-t border-gray-100">
                    {option.instance_id === SPECIAL_SHIPPING_INSTANCE_ID && (
                      <EcontOfficeSelector
                        selectedCityId={selectedCityId}
                        setSelectedCityId={setSelectedCityId}
                        cities={cities}
                        filteredOffices={filteredOffices}
                        selectedOffice={selectedOffice}
                        setSelectedOffice={setSelectedOffice}
                      />
                    )}

                    {option.instance_id === SPECIAL_SHIPPING_INSTANCE_ID_2 && (
                      <SpeedyOfficeSelector
                        selectedSiteId={selectedSiteId}
                        setSelectedSiteId={setSelectedSiteId}
                        sites={sites}
                        filteredSpeedy2Offices={filteredSpeedy2Offices}
                        selectedSpeedy2Office={selectedSpeedy2Office}
                        setSelectedSpeedy2Office={setSelectedSpeedy2Office}
                      />
                    )}
                    
                    {option.instance_id === PICKUP_SHIPPING_INSTANCE_ID && (
                      <PickupAddressDisplay />
                    )}
                    
                    {option.instance_id === ADDRESS_SHIPPING_INSTANCE_ID && (
                      <AddressShippingForm
                        formData={formData}
                        handleInputChange={handleInputChange}
                      />
                    )}
                  </div>
                )}
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default ShippingMethodSelector; 